module.exports = __webpack_public_path__ + "publisher/media/logo.f57bd8d6.svg";